import type { Node } from 'slate';

import { Element } from 'slate';

import type { FigureElement } from '@ui/MarkdownEditor/types';

export const type = 'figure';
export const isFigure = (node: Node): node is FigureElement => Element.isElementType<FigureElement>(node, type);
